import NumberFlowBase, { type Format, type Value } from '@number-flow/react'
import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

/**
 * NumberFlow (https://number-flow.barvian.me/) s výchozím nastavením invo.space:
 * česká lokalizace, nenápadné časování a respekt k omezení pohybu.
 * Části čísla jdou stylovat přes ::part(integer | fraction | left | right), viz globals.css.
 */
export type NumberFlowProps = ComponentProps<typeof NumberFlowBase>

export const NumberFlow = ({ className, locales = 'cs-CZ', ...props }: NumberFlowProps) => (
  <NumberFlowBase
    locales={locales}
    // bez vodorovného posunu celého čísla při změně šířky, jen přetočení číslic
    transformTiming={{ duration: 0, easing: 'linear' }}
    // jemné: kratší přetočení s měkkým dojezdem, každá číslice jde nejkratší cestou (trend 0)
    spinTiming={{ duration: 360, easing: 'cubic-bezier(0.25, 1, 0.5, 1)' }}
    opacityTiming={{ duration: 200, easing: 'ease-out' }}
    trend={0}
    respectMotionPreference
    className={cn('tabular', className)}
    {...props}
  />
)

export type { Format, Value }
